export default __webpack_public_path__ + "static/media/no_search_results_image.3a2d1b1c.png";